module.exports = __webpack_public_path__ + "media/assets/icons/arrow-down-893c78677a04b3ecaaaa112e2b4ff66a.svg";